import api from './api';

export interface CdnName {
  id: number;
  user_id: number;
  cdn_name: string;
  domain: string | null;
  first_seen_at: string;
  last_seen_at: string;
  times_seen: number;
  is_blacklisted: number;
  notes: string | null;
}

export const cdnService = {
  async list(): Promise<CdnName[]> {
    const response = await api.get<CdnName[]>('/cdn');
    return response.data;
  },

  async create(data: { cdn_name: string; domain?: string; notes?: string }): Promise<CdnName> {
    const response = await api.post<CdnName>('/cdn', data);
    return response.data;
  },

  async update(id: number, data: { cdn_name?: string; domain?: string; notes?: string }): Promise<CdnName> {
    const response = await api.put<CdnName>(`/cdn/${id}`, data);
    return response.data;
  },

  async toggleBlacklist(id: number, blacklisted: boolean): Promise<void> {
    await api.put(`/cdn/${id}/blacklist`, { blacklisted });
  },

  async updateNotes(id: number, notes: string): Promise<void> {
    await api.put(`/cdn/${id}/notes`, { notes });
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/cdn/${id}`);
  },
};
